import styled from 'styled-components'

export const ShippedLabel = styled.div`
  gap: var(--space-300);
`
